export default {
    "1": "启用",
    "2": "停用",
    "3": "帮助中心",
    "4": "编辑",
    "5": "复制",
    "6": "创建",
    "7": "数据总览",
    "8": "标签集市",
    "9": "用户标签",
    "10": "家庭标签",
    "11": "用户标签列表",
    "12": "家庭标签列表",
    "13": "标签体系说明",
    "14": "标签状态",
    "15": "家庭群体",
    "16": "个体人群",
    "17": "人群对比",
    "18": "标签圈人",
    "19": "LBS人群",
    "20": "批量获取地址",
    "21": "自定义上传",
    "22": "lookalike人群",
    "23": "组合人群",
    "24": "投后人群",
    "25": "算法人群",
    "26": "三方DMP人群",
    "27": "流量圈人",
    "28": "人群包拆分",
    "29": "活动人群",
    "30": "即将失效",
    "31": "流量洞察",
    "32": "配置中心",
    "33": "订单标签组合",
    "34": "电商标签每周流量洞察",
    "35": "问询管理",
    "36": "问询源包",
    "37": "推送列表",
    "38": "算法模型",
    "39": "标签配置",
    "40": "问询 API",
    "41": "创建问询API",
    "42": "编辑问询API",
    "43": "人群下载",
    "44": "FTP 管理",
    "45": "平台管理",
    "46": "失效人群",
    "47": "问询标签",
    "48": "项目标签",
    "49": "同步控制",
    "50": "自定义标签",
    "51": "标签发布",
    "52": "统计报表",
    "53": "三方问询",
    "54": "全量保存",
    "55": "匹配保存",
    "56": "已上线",
    "57": "已下线",
    "58": "京东系",
    "59": "超级红包",
    "60": "福利购",
    "61": "签到红包",
    "62": "福利直降",
    "63": "已创建",
    "64": "计算中",
    "65": "计算完成",
    "66": "计算失败",
    "67": "已删除",
    "68": "搜索项目名称/模型名称/种子人群ID",
    "69": "全部状态",
    "70": "创建模型",
    "71": "编辑成功",
    "72": "创建成功",
    "73": "创建须知",
    "74": "模型阈值区间0.01-0.99，默认为模型推荐阈值，可修改。",
    "75": "预测人群量级，单位为万，数值区间10-30000，即量级不超过3亿。指定量级时，按照预测得分高低顺序输出设备。",
    "76": "阈值和量级二选一输入数值，两者必须有一个有值。",
    "77": "新增预测模型需求，请发送邮件至ad-pm。",
    "78": "人群名称",
    "79": "请填写人群名称",
    "80": "输入字符过长",
    "81": "人群包名称不能包含/",
    "82": "所属项目",
    "83": "请选择所属项目",
    "84": "ID标识",
    "85": "请选择ID标识",
    "86": "请选择算法模型",
    "87": "模型阈值",
    "88": "请填写模型阈值",
    "89": "推荐阈值为*.**，数值区间0.01-0.99",
    "90": "预测人群量级（万）",
    "91": "请输入量级数值",
    "92": "取消",
    "93": "时间周期最长支持{}天",
    "94": "请选择时间周期",
    "95": "请选择订单标签任务",
    "96": "上传创建投后人群",
    "97": "时间周期最长支持选择六个月",
    "98": "自定义频次区间为左闭右开；比如设置1-6，则计算 1&lt;=频次&lt;6的数据",
    "99": "上传文件支持xlsx，xls格式",
    "100": "上传文件后需先进行校验，系统将校验所填订单/项目/计划ID是否存在于所选广告主下，请校验通过后再进行创建",
    "101": "上传模板样式",
    "102": "上传模板样式图",
    "103": "加密方式：",
    "104": "ID标识原值及加密说明",
    "105": "人群包如需要下载或者推送ftp，人群包名称建议使用英文字母和数字、下划线_组成，避免中文乱码显示问题。",
    "106": "ID标识只能选择纯明文（IDFA/OAID）或者纯密文（IDFA_MD5加密/IMEI_MD5加密/OAID_MD5加密）",
    "107": "广告主",
    "108": "搜索后显示",
    "109": "时间周期",
    "110": "转化",
    "111": "频次",
    "112": "不限",
    "113": "{}次及以上",
    "114": "自定义",
    "115": "次",
    "116": "终端类型",
    "117": "是否生成洞察",
    "118": "是",
    "119": "否",
    "120": "ID类型",
    "121": "加密方式",
    "122": "请选择加密方式",
    "123": "同天猫",
    "124": "同数坊&京东U+",
    "125": "不加密",
    "126": "是否自动更新",
    "127": "文件上传方式",
    "128": "本地文件上传",
    "129": "订单标签叉乘",
    "130": "上传文件",
    "131": "选择文件",
    "132": "支持",
    "133": "订单标签任务",
    "134": "下载模板",
    "135": "检查",
    "136": "时",
    "137": "累计更新",
    "138": "覆盖更新",
    "139": "活动人群ID标识只能选择IDFA和OAID",
    "140": "累计更新：",
    "141": "即增量更新，指人群包中保留自问询开始，所有的问询结果。",
    "142": "覆盖更新：",
    "143": "即全量更新，指人群包中只保留最新问询结果。",
    "144": "人群包ID超过数量限制,请先进行拆分",
    "145": "选择的ID标识与源人群包ID标识不一致",
    "146": "注意事项",
    "147": "1、不支持ID数量超过两亿的人群包生成三方DMP人群（oss离线问询除外）, 请先进行拆分再创建",
    "148": "前往拆分",
    "149": "2、文件目录下只保留问询文件，问询文件即您本次创建人群包所需要上传的文件。",
    "150": "3、当源人群类型为文件上传时，ftp中文件格式只能为csv、txt格式，文件数量可以是多个，文件内容只有第一列数据为设备ID,所有文件设备ID数量不超过2亿，文件大小不超过6G。",
    "151": "名称",
    "152": "问询频次",
    "153": "请选择问询频次",
    "154": "每日",
    "155": "每两天",
    "156": "每周",
    "157": "日问询时间",
    "158": "2+次问询包",
    "159": "更新方式",
    "160": "请选择更新方式",
    "161": "请选择开始时间",
    "162": "请选择结束时间",
    "163": "结束时间应大于开始时间",
    "164": "系统异常",
    "165": "1、时间周期最长支持选择3个月",
    "166": "时间类型",
    "167": "绝对时间",
    "168": "相对时间",
    "169": "开始日期",
    "170": "结束日期",
    "171": "最近",
    "172": "时间周期应大于0且小于等于90",
    "173": "天",
    "174": "请输入DealID",
    "175": "批量延期成功",
    "176": "批量延期",
    "177": "延期",
    "178": "本次已选中{}个人群包",
    "179": "有效期延长至",
    "180": "延期至",
    "181": "已同步状态同时延期",
    "182": "人群ID",
    "183": "最新人群数量",
    "184": "上传总数量",
    "185": "人群类型",
    "186": "提交日期",
    "187": "创建人",
    "188": "批量下载人群信息",
    "189": "本次下载人群信息已选中{}个人群包。下载信息选择：",
    "190": "源包类型为:{}, 不支持自动更新",
    "191": "今日延期次数已满",
    "192": "下线成功",
    "193": "上线成功",
    "194": "模型ID",
    "195": "模型路径",
    "196": "模型名称",
    "197": "种子人群ID",
    "198": "推荐阈值",
    "199": "状态",
    "200": "创建时间",
    "201": "修改时间",
    "202": "操作",
    "203": "下线",
    "204": "上线",
    "205": "请输入模型路径",
    "206": "项目名称",
    "207": "请输入项目名称",
    "208": "模型目标",
    "209": "请输入模型目标",
    "210": "请选择ID类型",
    "211": "模型上线日期",
    "212": "请选择模型上线日期",
    "213": "请输入推荐阈值",
    "214": "请输入推荐阈值，0.01-0.99之间",
    "215": "种子人群包ID",
    "216": "请输入种子人群包ID",
    "217": "模型描述",
    "218": "请输入文本描述",
    "219": "订单标签是指订单创建时所打的标签，顺序如下图。实现叉乘的前提是同一顺序的标签属于同一类。比如说标签1都是广告形式标签，标签2都是人群标签。",
    "220": "任务名称",
    "221": "请填写任务名称",
    "222": "任务名称不能包含/",
    "223": "人群名称前缀",
    "224": "请填写人群名称前缀",
    "225": "人群名称前缀不能包含/",
    "226": "请选择广告主",
    "227": "项目",
    "228": "请选择项目",
    "229": "计划",
    "230": "请选择计划",
    "231": "订单标签",
    "232": "请配置订单标签",
    "233": "订单标签任务名称搜索",
    "234": "新建任务",
    "235": "创建说明",
    "236": "1、YOYI源包上传目录为设备上传最新日期路径。每周日更新。",
    "237": "2、项目简称和策略简称只能英文字母和数字组成，不带任何特殊符号。",
    "238": "3、问询结果格式:download/项目简称/策略简称，问询结果是系统根据\"项目简称\"和\"策略简称\"自动生成的文件路径.",
    "239": "源包上传目录",
    "240": "项目简称",
    "241": "请填写项目简称",
    "242": "只能包含英文字母+数字，不带特殊符号",
    "243": "长度不超过20个字母",
    "244": "策略简称",
    "245": "请填写策略简称",
    "246": "只能包含英文字母+数字",
    "247": "运营需求",
    "248": "请填写运营需求",
    "249": "问询结果",
    "250": "名称长度不能超过50",
    "251": "请输入50字以内人群名称",
    "252": "批量人群洞察",
    "253": "本次已选中{}个人群包，确认后洞察开始计算",
    "254": "新建洞察任务成功",
    "255": "批量关注",
    "256": "本次关注已选中{}个人群包",
    "257": "关注成功",
    "258": "人群名称模糊搜索",
    "259": "京东人群",
    "260": "提示：您今天已延期{}个，还可延期{}个",
    "261": "生成中",
    "262": "已生成",
    "263": "序号",
    "264": "任务状态",
    "265": "完成时间",
    "266": "查看详情",
    "267": "下载",
    "268": "已失效",
    "269": "执行中",
    "270": "待执行",
    "271": "已完成",
    "272": "请填写 adzone_id 和 offer_id",
    "273": "请填写媒体pid",
    "274": "请选择红包类型",
    "275": "请输入adzone_id",
    "276": "请输入offer_id",
    "277": "请填写问询结果！",
    "278": "请输入Cosmose人群项目ID，不支持多个ID上传",
    "279": "请输入人群回传路径，格式为:/联通/项目简称_策略简称",
    "280": "请输入人群回传路径，格式为:电信/yy_industry",
    "281": "请选择问询结果！",
    "282": "请选择问询结果",
    "283": "请输入媒体pid",
    "284": "仅限英文字母/数字",
    "285": "请输入一个策略简称，仅限英文字母/数字",
    "286": "请从OSS浏览器复制相应路径,如 taobao/imei_download/result_cuhuo_code",
    "287": "请输入一个RTQID",
    "288": "请输入指定量级，如1000",
    "289": "请填写文件路径",
    "290": "路径校验失败",
    "291": "校验失败",
    "292": "数据文件HDFS路径",
    "293": "填写/复制一个文件路径",
    "294": "FTP 名称",
    "295": "请选择FTP",
    "296": "上传文件目录",
    "297": "请填写文件目录",
    "298": "人群包",
    "299": "文件上传",
    "300": "HDFS路径",
    "301": "源包来源",
    "302": "全量",
    "303": "指定数量",
    "304": "个，约 {} 万",
    "305": "批量复制",
    "306": "批量下载信息",
    "307": "{}个",
    "308": "{}个人群",
    "309": "请选择订单标签",
    "310": "最多可选择{}个订单标签叉乘",
    "311": "最多配置{}个标签值",
    "312": "配置标签值",
    "313": "请输入标签值名称，每行一个，最多{}行",
    "314": "标签{}",
    "315": "选择订单标签",
    "316": "有已选标签中未配置，请检查",
    "317": "叉乘后人群数量需要小于{}个，请重新配置标签",
    "318": "失败",
    "319": "实际人群数量会小于等于标签组合数量",
    "320": "单个人群支持最多4000个订单ID",
    "321": "源包人群名称",
    "322": "源包人群类型",
    "323": "副本人群名称",
    "324": "请输入人群包名称",
    "325": "代理商为空，选择代理商后再保存。",
    "326": "人群包名称为空，选择填写人群包名称后再保存。",
    "327": "批量复制成功",
    "328": "批量复制失败",
    "329": "批量创建DNA复制人群",
    "330": "代理商名称",
    "331": "请选择代理商，单选",
    "332": "DNA复制人群包名称",
    "333": "共批量选择{}个人群包，其中{}个人群包进行复制，见上方清单。",
    "334": "保存",
    "335": "单个文件最多支持200行，即一次最多支持批量创建200个人群",
    "336": "全部人群",
    "337": "我的人群",
    "338": "操作提示",
    "339": "确认恢复该人群包？",
    "340": "恢复成功",
    "341": "恢复失效人群",
    "342": "查看",
    "343": "DNA复制人群",
    "344": "请选择代理商",
    "345": "普通",
    "346": "高级",
    "347": "请上传Excel文件",
    "348": "只支持 excel, csv, txt",
    "349": "上传成功",
    "350": "文件设备ID",
    "351": "是否匹配洞察",
    "352": "数据保存方式",
    "353": "支持 xls, xlsx, csv, txt",
    "354": "上传须知",
    "355": "“文件设备ID”方式上传的文件只能有一列数据，如匹配结果为0，请先自查文件内容是否只有一列。",
    "356": "文件大小最大支持1G，如需上传大于1G的文件，请联系管理员。",
    "357": "“数据文件”方式，请输入HDFS路径，如：/user/ads/dmp/crowdDayTag/support-01",
    "358": "上传目的：上传创建完成后不会产生洞察，可立即设置同步。",
    "359": "提前一天",
    "360": "当选择oaid小写加密和全量保存时，已匹配ID将自动转换成oaid原值加密，未匹配ID直接保存上传的oaid小写加密数据。",
    "361": "文件最大{}G!",
    "362": "批量创建人群包对应数据文件",
    "363": "目标YES数量",
    "364": "请选择目标YES数量",
    "365": "为了不影响投放时间，请至少{}进行人群包上传,创建,并点击同步,直至同步完成",
    "366": "电商洞察",
    "367": "按名称搜索",
    "368": "人群数量：共计 {} 个",
    "369": "文件目录下只保留所需生成HDFS路径的文件。如有文件大小为0，则该文件不生成HDFS路径。",
    "370": "同一个文件夹中，所有文件大小之和小于2G。文件过大，可能受网络等影响导致任务失败。",
    "371": "文件内容只能有一列设备ID。",
    "372": "HDFS路径生成一个月之后将自动失效。请合理安排创建为上传人群。",
    "373": "FTP名称",
    "374": "请输入文件目录",
    "375": "请输入文件目录。如/upload/文件夹名称",
    "376": "HDFS生成方式",
    "377": "一对一",
    "378": "多对一",
    "379": "一对一：目录中的每个文件对应一个HDFS路径",
    "380": "多对一：目录中的多个文件合并成一个HDFS路径",
    "381": "保存成功",
    "382": "请输入FTP名称",
    "383": "FTP地址",
    "384": "请输入JAR包路径",
    "385": "请填写FTP地址",
    "386": "协议",
    "387": "端口",
    "388": "请对API支持的功能进行描述",
    "389": "请填写端口",
    "390": "账号",
    "391": "请填写账号",
    "392": "密码",
    "393": "请填写密码",
    "394": "目录",
    "395": "请填写目录",
    "396": "文件更新",
    "397": "请选择文件更新",
    "398": "覆盖",
    "399": "按日期追加",
    "400": "任务名称搜索",
    "401": "是否删除此条FTP",
    "402": "删除成功",
    "403": "维护时间",
    "404": "删除",
    "405": "HDFS数量",
    "406": "失效日期",
    "407": "上传创建",
    "408": "交",
    "409": "并",
    "410": "减",
    "411": "组合条件",
    "412": "组合结果",
    "413": "请选择人群",
    "414": "请选择需要组合的人群包",
    "415": "括号数量不匹配",
    "416": "不能以符号结尾",
    "417": "组合错误",
    "418": "重置",
    "419": "数量",
    "420": "类型",
    "421": "人群包已添加",
    "422": "共 {} 条",
    "423": "覆盖 YOYI ID",
    "424": "覆盖 Household ID 数",
    "425": "非",
    "426": "无",
    "427": "上一次",
    "428": "请配置标签组合",
    "429": "开始不能是符号，若是符号必须是\"(\"或\"非\"",
    "430": "\"非\"前必须有符号",
    "431": "\"(\"前不能为标签或者\")\"",
    "432": "请注意标签符号间隔",
    "433": "\")\"后面必须是符号",
    "434": "不能以非\")\"符号作为结束",
    "435": "括号不匹配",
    "436": "‘非’前需要有‘交’或者‘并’",
    "437": "选择条件",
    "438": "请选择标签",
    "439": "人群正在创建请稍后",
    "440": "编辑人群名称成功",
    "441": "默认填充",
    "442": "查看覆盖人群",
    "443": "搜索标签",
    "444": "匹配标签",
    "445": "已选标签",
    "446": "标签列表",
    "447": "请输入匹配内容，如: \"男,智能穿戴\"",
    "448": "默认条件",
    "449": "未匹配标签",
    "450": "已存在标签",
    "451": "请输入搜索内容",
    "452": "请输入标签名称",
    "453": "返回上级",
    "454": "LBS圈人",
    "455": "进入LBS搜索",
    "456": "地图创建",
    "457": "开",
    "458": "关",
    "459": "开启此开关将会生成每个LBS单独的人群包和人群集合的人群包；关闭此开关将只会生成人群集合的人群包",
    "460": "使用手册",
    "461": "按任务名称搜索",
    "462": "创建地址任务",
    "463": "是否确认删除？",
    "464": "是否指定地名",
    "465": "指定地名",
    "466": "关键词",
    "467": "搜索条件",
    "468": "最多上传1个文件!",
    "469": "仅支持",
    "470": "任务名称不能包含特殊字符",
    "471": "批量获取地址指定地名模板",
    "472": "百度查询",
    "473": "请输入任务名称",
    "474": "请输入任务名称，不超过30个汉字",
    "475": "请选择是否指定地名",
    "476": "请上传文件!",
    "477": "POI关键词",
    "478": "请输入POI关键词",
    "479": "输入关键词，支持多个关键字并集检索，不同关键字间以$符号分隔，最多支持3个关键字检索。如:”银行$酒店”",
    "480": "所属城市",
    "481": "请选择所属城市",
    "482": "请输入关键字",
    "483": "选中地域",
    "484": "全部删除",
    "485": "文件最大{}M!",
    "486": "请上传Excel文件!",
    "487": "开启生成LBS子包开关将会生成每个LBS单独的人群包和人群集合的人群包；关闭此开关将只会生成人群集合的人群包；如无特殊需求建议关闭",
    "488": "周边范围区间为左开右闭；比如设置1~5KM，则计算1<周边半径<=5的数据",
    "489": "上传文件格式支持xls,xlsx",
    "490": "上传文件需包含三列信息：地名、详细地址和所在城市。详见模板",
    "491": "最近半个月活跃人数",
    "492": "最近一个月活跃人数",
    "493": "最近两个月活跃人数",
    "494": "生成LBS子包",
    "495": "所选范围",
    "496": "请至少选择一个位置",
    "497": "请设置距离为 0-5km",
    "498": "请确认范围大小顺序",
    "499": "编辑人群成功",
    "500": "新建人群成功",
    "501": "人群没有修改",
    "502": "已选结果",
    "503": "清空",
    "504": "提交",
    "505": "全国",
    "506": "详情",
    "507": "地址",
    "508": "电话",
    "509": "没有匹配到经纬度",
    "510": "搜经纬度、查地点、找门店名",
    "511": "批量搜索",
    "512": "筛选城市",
    "513": "本页全选",
    "514": "扩散中",
    "515": "种子包名称",
    "516": "扩散条件",
    "517": "种子包数量",
    "518": "地域",
    "519": "媒体偏好",
    "520": "消费偏好",
    "521": "消费场景",
    "522": "扩散用户数",
    "523": "拆分数量不能为0",
    "524": "拆分包名称不能为空",
    "525": "目前只支持个体人群, ID类型为 Device 的人群包进行拆分",
    "526": "选择的ID标识与人群包的不匹配！",
    "527": "创建任务",
    "528": "选项只包含已生成，同步中，已同步的人群包.不包含不生成洞察的上传人群",
    "529": "选择人群",
    "530": "拆分文件数量",
    "531": "包",
    "532": "请输入包{}名称",
    "533": "条",
    "534": "约",
    "535": "未开始问询",
    "536": "开始问询",
    "537": "问询完成",
    "538": "暂停",
    "539": "操作成功",
    "540": "操作失败",
    "541": "推送日期",
    "542": "源包名称",
    "543": "问询开始时间",
    "544": "问询结束时间",
    "545": "问询数量",
    "546": "问询成功数量",
    "547": "问询失败数量",
    "548": "确认开始问询?",
    "549": "确认暂停问询?",
    "550": "暂停问询",
    "551": "确认重新问询?",
    "552": "重新问询",
    "553": "提升",
    "554": "下降",
    "555": "全部",
    "556": "待下发",
    "557": "下发中",
    "558": "成功",
    "559": "请筛选状态",
    "560": "推送开始时间",
    "561": "推送结束时间",
    "562": "推送数量",
    "563": "确认重推?",
    "564": "重推",
    "565": "每个文件匹配需1.5小时，请您耐心等待，计算完成时间与提交文件的多少有关。",
    "566": "同天猫：",
    "567": "IMEI MD5加密：原值小写，加密后32位小写；",
    "568": "IDFA MD5加密：原值大写，加密后32位小写；",
    "569": "OAID MD5加密：原值，加密后32位小写。",
    "570": "同数坊&京东U+：",
    "571": "OAID MD5加密：原值小写，加密后32位小写。",
    "572": "不加密：",
    "573": "IDFA：原值大写，长度为36位；OAID：原值，长度不定。",
    "574": "渠道",
    "575": "请输入渠道",
    "576": "直投媒体",
    "577": "请输入直投媒体",
    "578": "广告位ID",
    "579": "请输入广告位ID",
    "580": "多个ID请用,号分隔",
    "581": "请填写开始时间",
    "582": "订单",
    "583": "请选择媒体",
    "584": "转化类型",
    "585": "请选择转化类型",
    "586": "无此人群",
    "587": "激活",
    "588": "唤活",
    "589": "注册",
    "590": "订单量",
    "591": "首购量",
    "592": "加购物车",
    "593": "收藏",
    "594": "app吊起",
    "595": "次日留存",
    "596": "其他",
    "597": "不回传",
    "598": "直投",
    "599": "联合频控",
    "600": "个人",
    "601": "家庭",
    "602": "同步中",
    "603": "已同步",
    "604": "匹配数量小于500",
    "605": "全部类型",
    "606": "转换人群",
    "607": "家庭人群",
    "608": "我关注的人群",
    "609": "第三方 cookie",
    "610": "最近半个月",
    "611": "最近一个月",
    "612": "最近两个月",
    "613": "活跃人数",
    "614": "地域分布",
    "615": "曝光",
    "616": "点击",
    "617": "曝光未点击",
    "618": "点击未转化",
    "619": "区间",
    "620": "源包",
    "621": "新包",
    "622": "源包+新包",
    "623": "IDFA MD5加密",
    "624": "IMEI MD5加密",
    "625": "Android ID MD5加密",
    "626": "OAID MD5加密",
    "627": "条件",
    "628": "人群类型ID",
    "629": "匹配数量",
    "630": "计划数量",
    "631": "人群扩散倍数",
    "632": "源包类型",
    "633": "源包ID类型",
    "634": "源包上传路径",
    "635": "匹配率",
    "636": "所属层级",
    "637": "自定义标签名称",
    "638": "总用户量",
    "639": "阈值",
    "640": "维护日期",
    "641": "数据更新时间",
    "642": "绝对值",
    "643": "确认",
    "644": "人群ID转换",
    "645": "转换人群名称",
    "646": "转换人群类别",
    "647": "转换人群ID类型",
    "648": "复制到Plus",
    "649": "请填写代理商名称",
    "650": "延期成功",
    "651": "失效时间",
    "652": "扩散成功",
    "653": "扩散人群",
    "654": "扩散",
    "655": "lookalike名称",
    "656": "请输入扩散后人群名称",
    "657": "人群扩散条件",
    "658": "请选择人群扩散条件",
    "659": "选择了不限，不能再选其它扩散条件",
    "660": "请填写扩散倍数",
    "661": "扩散倍数1~10倍",
    "662": "倍",
    "663": "当前状态数量",
    "664": "人群总数",
    "665": "开始组合",
    "666": "人群包自动更新",
    "667": "任务暂未开始，请稍后再试",
    "668": "正在生成人群包，请稍后再试",
    "669": "人群包正在同步中，请稍后再试",
    "670": "人群包已失效，不支持自动更新",
    "671": "活动人群不支持自动更新",
    "672": "修改自动更新状态为",
    "673": "非自动更新",
    "674": "自动更新",
    "675": "修改成功",
    "676": "最多选择20个人群包进行组合",
    "677": "ID 类型不同不能进行组合",
    "678": "未生成 lookalike，不支持组合",
    "679": "人群包已失效，不支持组合",
    "680": "最多选择2个人群包进行对比",
    "681": "比较人群",
    "682": "ID类型为空的人群不支持对比",
    "683": "人群转换",
    "684": "人群包已失效，不支持扩散",
    "685": "只支持 Household ID 与 Device 互转",
    "686": "“此人群包为PLUS创建，不支持复制到PLUS",
    "687": "正在生成人群包，不可删除",
    "688": "正在同步人群包，不可删除",
    "689": "人群包已同步到PLUS，不可删除",
    "690": "DMP 人群包不能删除",
    "691": "确定删除人群: {} ?",
    "692": "正在同步人群包，不支持编辑",
    "693": "人群包已失效，不支持编辑",
    "694": "模糊搜索生成的LBS，不支持编辑",
    "695": "推送 FTP",
    "696": "洞察计算中",
    "697": "人群洞察",
    "698": "人群洞察计算中，请计算完成后点击人群洞察按钮查看洞察结果",
    "699": "正在生成洞察，请稍后再试",
    "700": "人群包已失效，不能进行洞察",
    "701": "此人群包没有选择生成洞察, 或ID类型不支持洞察",
    "702": "请先选择ID类型",
    "703": "人数少于{}不能进行洞察",
    "704": "人群包已失效，不能查看详情",
    "705": "人数少于500或大于100万不能进行扩散",
    "706": "取消关注",
    "707": "关注",
    "708": "失效人群不可设置关注操作",
    "709": "确定取消关注:",
    "710": "确定关注:",
    "711": "更新记录",
    "712": "人群包名称",
    "713": "人群包ID",
    "714": "数据日期",
    "715": "当日增量",
    "716": "总数量",
    "717": "人群包更新记录",
    "718": "保存本页为图片",
    "719": "“人群洞察报告”下载",
    "720": "个人画像下载",
    "721": "高",
    "722": "低",
    "723": "北京市",
    "724": "天津市",
    "725": "上海市",
    "726": "重庆市",
    "727": "河北省",
    "728": "山西省",
    "729": "辽宁省",
    "730": "吉林省",
    "731": "黑龙江省",
    "732": "江苏省",
    "733": "浙江省",
    "734": "安徽省",
    "735": "福建省",
    "736": "江西省",
    "737": "山东省",
    "738": "河南省",
    "739": "湖北省",
    "740": "湖南省",
    "741": "广东省",
    "742": "海南省",
    "743": "四川省",
    "744": "贵州省",
    "745": "云南省",
    "746": "陕西省",
    "747": "甘肃省",
    "748": "青海省",
    "749": "台湾省",
    "750": "内蒙古自治区",
    "751": "广西壮族自治区",
    "752": "西藏自治区",
    "753": "宁夏回族自治区",
    "754": "新疆维吾尔自治区",
    "755": "香港特别行政区",
    "756": "澳门特别行政区",
    "757": "占人群包比重",
    "758": "TGI指数",
    "759": "人群数量",
    "760": "占比",
    "761": "概览画像",
    "762": "家庭属性",
    "763": "电视品牌",
    "764": "APP类别",
    "765": "人口属性",
    "766": "上网特征",
    "767": "TOP50 显著特征",
    "768": "家庭结构",
    "769": "性别分布",
    "770": "年龄分布",
    "771": "成员年龄",
    "772": "跨屏数量",
    "773": "节目偏好",
    "774": "兴趣偏好",
    "775": "购物倾向",
    "776": "选择条件: 无",
    "777": "时间选择",
    "778": "种子人群数",
    "779": "扩散人群数",
    "780": "洞察日期",
    "781": "洞察进度",
    "782": "洞察链接",
    "783": "洞察完成时间",
    "784": "洞察创建时间",
    "785": "LBS名称",
    "786": "城市",
    "787": "人群名称/人群ID模糊搜索",
    "788": "任务进度",
    "789": "创建流量洞察",
    "790": "无匹配人群",
    "791": "人群流量洞察正在生成，请稍后再试",
    "792": "人群流量洞察已创建成功",
    "793": "人群流量洞察创建",
    "794": "新建洞察",
    "795": "源人群类型",
    "796": "源人群包",
    "797": "请选择 API",
    "798": "标签名称模糊搜索",
    "799": "标签名称",
    "800": "添加人群包",
    "801": "添加子标签",
    "802": "请输入叶子标签名称",
    "803": "长度不超过{}字节",
    "804": "子标签已保存",
    "805": "标签id",
    "806": "叶子标签名称",
    "807": "输入标签名称，长度不超过50字节",
    "808": "人群包添加成功",
    "809": "人群包超过20个",
    "810": "永久",
    "811": "创建人群",
    "812": "注意：文件格式为：店名、地理位置、所在城市",
    "813": "注意：如果支持的LBS较多，输出结果可能需要48小时以上，还请谨慎提交并耐心等待",
    "814": "请输入20字以内人群名称",
    "815": "请输入搜索条件",
    "816": "请输入地方名称",
    "817": "同步进度",
    "818": "待开始",
    "819": "读取中",
    "820": "返回首页",
    "821": "用户无权限",
    "822": "用户无权限访问该页面...",
    "823": "登录失败",
    "824": "DNA是悠易互通旗下的、面向开发者推出的用户行为分析产品，帮助客户通过精细化运营工具实现产品的快速增长。",
    "825": "账号：",
    "826": "请输入用户名!",
    "827": "密码：",
    "828": "请输入密码!",
    "829": "阅读并接受",
    "830": "悠易隐私政策",
    "831": "登录",
    "832": "退出登录",
    "833": "人群报表",
    "834": "请填写自定义标签名称",
    "835": "自定义标签名称模糊搜索",
    "836": "确认删除该自定义标签？",
    "837": "全部标签",
    "838": "我的标签",
    "839": "API名称",
    "840": "API平台ID",
    "841": "描述",
    "842": "是否删除此条API",
    "843": "按API名称搜索",
    "844": "请输入API名称",
    "845": "API描述",
    "846": "人群包创建",
    "847": "并行度",
    "848": "最大为100",
    "849": "授权代理商",
    "850": "搜索TASK名称、TASKID、APP名称",
    "851": "是否删除此条",
    "852": "TASK名称",
    "853": "任务类型",
    "854": "app名称",
    "855": "创建须知：",
    "856": "由于taskid对应的app名称和所属系别修改会影响标签数据，运营注意以下事项：",
    "857": "创建时，需要确认无误才可保存，",
    "858": "若taskid未开始问询前，可以编辑，",
    "859": "若taskid已经问询，修改taskid、app名称、app所属系别，需及时通知产品和技术回滚数据。",
    "860": "请选择API名称",
    "861": "选择API名称",
    "862": "请输入TASKID",
    "863": "请输入TASK名称",
    "864": "TASK类型",
    "865": "请输入TASK类型",
    "866": "APP名称",
    "867": "请输入APP名称",
    "868": "所属系别",
    "869": "请输入所属系别",
    "870": "开始日期-结束日期",
    "871": "平台名称",
    "872": "请输入台名称",
    "873": "请输入平台符号",
    "874": "平台符号",
    "875": "确认删除？",
    "876": "人群包下载",
    "877": "一方标签下载",
    "878": "下载ID类型",
    "879": "文件数量",
    "880": "复制成功",
    "881": "复制链接",
    "882": "是否删除此条记录",
    "883": "文件不存在",
    "884": "是否删除此条记录？",
    "885": "下载类型",
    "886": "待定",
    "887": "通过",
    "888": "拒绝",
    "889": "已拒绝",
    "890": "已通过",
    "891": "同步成功",
    "892": "ID数量",
    "893": "同步用户",
    "894": "同步广告主",
    "895": "提交时间",
    "896": "结果",
    "897": "审核时间",
    "898": "审核人",
    "899": "用户",
    "900": "地理位置",
    "901": "DNA家庭标签在媒体偏好，消费偏好，节目偏好，地理位置每个维度Household ID覆盖量前100的叶子标签",
    "902": "DNA标签在地理位置，媒体偏好，消费偏好，消费场景每个维度YOYI ID覆盖量前100的叶子标签",
    "903": "标签云",
    "904": "展示HouseholdID和其中可跨屏部分的数量情况",
    "905": "OAID，ANDROID,YOYI Cookie都表示能与主ID的数量；（主ID包括IMEI、OAID、IDFA、Cookie）",
    "906": "ID 图谱",
    "907": "标签分布",
    "908": "基础分类"
}